import React from 'react';

export const UserRepsPage: React.FC = React.memo(() => {
  return null;
});
